import { render, staticRenderFns } from "./MatchNotify.vue?vue&type=template&id=30b63bfe"
import script from "./MatchNotify.vue?vue&type=script&lang=js"
export * from "./MatchNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports